import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PricingSection from '../components/PricingSection';
import Seo from '../seo/Seo';
import { PAGE_SEO } from '../seo/pageSeoConfig';
import CollapsibleSeoContent from '../components/seo/CollapsibleSeoContent';
import { getSeoContent, getSeoFaqSchema } from '../seo/seoContentData';

const pricingSeo = PAGE_SEO['/pricing'];

function PricingPage() {
  return (
    <div className="page landing-bg">
      <Seo
        title={pricingSeo.title}
        description={pricingSeo.description}
        canonicalPath="/pricing"
        structuredData={[getSeoFaqSchema('/pricing')].filter(Boolean)}
      />
      <Navbar />
      <main className="container section">
        <h1>{pricingSeo.h1}</h1>
        <p>{pricingSeo.description}</p>
      </main>
      <PricingSection bleed />
      <CollapsibleSeoContent {...getSeoContent('/pricing')} />
      <Footer />
    </div>
  );
}

export default PricingPage;
